import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  postAuthVerifyPhoneCode,
  type VerifyPhoneCodeRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { PARTY_QUERY_KEY } from "Api/Queries/Party/usePartyQuery";
import { phoneVerificationStatusKeys } from "Api/Queries/Auth/usePhoneVerificationStatusQuery";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useVerifyPhoneCodeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (request: VerifyPhoneCodeRequest) => postAuthVerifyPhoneCode(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: phoneVerificationStatusKeys.all,
      });
      // The verified phone is also written to the person Party's phone field.
      queryClient.invalidateQueries({ queryKey: [PARTY_QUERY_KEY] });
      onSuccess?.();
    },
    onError,
  });
};
